import { render, staticRenderFns } from "./addExaminationPaper.vue?vue&type=template&id=3235bd4e&scoped=true"
import script from "./addExaminationPaper.vue?vue&type=script&lang=js"
export * from "./addExaminationPaper.vue?vue&type=script&lang=js"
import style0 from "./addExaminationPaper.vue?vue&type=style&index=0&id=3235bd4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3235bd4e",
  null
  
)

export default component.exports